import React from 'react';
import MiscellanyOrderRowProperties from "./MiscellanyOrderRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import MiscellanyOrderRowMedium from "./MiscellanyOrderRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import MiscellanyOrderRowSmall from "./MiscellanyOrderRowSmall";


const MiscellanyOrderRow: React.FC<MiscellanyOrderRowProperties> = ({
                                                                    miscellanyOrder,
                                                                    selectedDeliveryOrderIds,
                                                                    onMiscellanyOrderSelect,
                                                                    onUpdate,
                                                                    filter,
                                                                    from,
                                                                    to,
                                                                }) => {
    return (
        <>
            <ViewSmall>
                <MiscellanyOrderRowSmall onUpdate={onUpdate} onMiscellanyOrderSelect={onMiscellanyOrderSelect}
                                       miscellanyOrder={miscellanyOrder}
                                       selectedDeliveryOrderIds={selectedDeliveryOrderIds}
                                       filter={filter} from={from} to={to}/>
            </ViewSmall>
            <ViewMedium>
                <MiscellanyOrderRowMedium onUpdate={onUpdate} onMiscellanyOrderSelect={onMiscellanyOrderSelect}
                                        miscellanyOrder={miscellanyOrder}
                                        selectedDeliveryOrderIds={selectedDeliveryOrderIds}
                                        filter={filter} from={from} to={to}/>
            </ViewMedium>
            <ViewLarge>
                <MiscellanyOrderRowMedium onUpdate={onUpdate} onMiscellanyOrderSelect={onMiscellanyOrderSelect}
                                        miscellanyOrder={miscellanyOrder}
                                        selectedDeliveryOrderIds={selectedDeliveryOrderIds}
                                        filter={filter} from={from} to={to}/>
            </ViewLarge>
        </>
    )
}

export default MiscellanyOrderRow;
